<template>
  <HeraFormDropdown
    v-model="valueModel"
    :list="sortByOptions"
    :label="$t('_web_competitions_tournaments-list-sort-label', 'Sort by')"
    variant="input-like"
    theme-dark
    class="col-2 mb-3 sort-by-filter"
  >
    <template slot="chosen" slot-scope="chosen">
      {{ $t(chosen.chosenItem.key, chosen.chosenItem.label) }}
    </template>

    <template slot="item" slot-scope="{ item }">
      {{ $t(item.key, item.label) }}
    </template>
  </HeraFormDropdown>
</template>

<script>
import { emptyString, emptyObject } from '@/utils/factories';
import valueModel from '@/mixins/valueModel';
import HeraFormDropdown from '@/components/molecules/form/HeraFormDropdown';

export default {
  components: {
    HeraFormDropdown,
  },
  mixins: [valueModel],
  props: {
    value: {
      type: Object,
      default: emptyObject,
    },
    label: {
      type: String,
      default: emptyString,
    },
  },
  data() {
    return {
      sortByOptions: [
        {
          key: '_web_sort-by_name_a-z',
          label: 'Name (A-Z)',
          value: {
            prop: 'name',
            order: 'asc',
          },
        },
        {
          key: '_web_sort-by_name_z-a',
          label: 'Name (Z-A)',
          value: {
            prop: 'name',
            order: 'desc',
          },
        },
        {
          key: '_web_sort-tournament_start_a-z',
          label: 'Newest first',
          value: {
            prop: 'tournament_start',
            order: 'desc',
          },
        },
        {
          key: '_web_sort-tournament_start_z-a',
          label: 'Oldest first',
          value: {
            prop: 'tournament_start',
            order: 'asc',
          },
        },
      ],
    };
  },
  computed: {
    valueModel: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  created() {
    this.$emit('input', this.sortByOptions[2]);
  },
};
</script>
